import { useLocation, useNavigate } from "react-router-dom";

import arrowRightGrayFill from "@/assets/images/console/arrowRightGrayFill.svg";
import icArrowOut from "@/assets/images/console/icArrowOut.svg";
import icLogout from "@/assets/images/console/icLogout.svg";
import { useAuthStore } from "@/store/console/useAuthStore";

import Nav from "./Nav";

const LocaMapper: Record<string, string[]> = {
    // 게시판 관리
    "/console/board/": ["게시판 관리"],
    "/console/board/166": ["게시판 관리", "공지사항"],
    "/console/board/167": ["게시판 관리", "자주 묻는 질문"],
    "/console/board/170": ["게시판 관리", "인스타그램"],
    "/console/board/171": ["게시판 관리", "관련자료"],
    // 디자인 관리
    "/console/design/": ["디자인 관리"],
    "/console/design/popup": ["디자인 관리", "팝업 관리"],
};

export default function Header() {
    const location = useLocation();
    const pathname = location.pathname;
    const navigate = useNavigate();
    const { m_name, clearUser } = useAuthStore();

    const locaList =
        Object.keys(LocaMapper)
            .sort((a, b) => b.length - a.length) // 긴 prefix 우선
            .find(key => pathname.startsWith(key)) || "";

    // 로그아웃
    const handleLogout = () => {
        clearUser();
        navigate("/console/login");
    };

    return (
        <header className="relative z-50">
            <div className="h-[80px] bg-white pl-[360px] border-b border-[#ddd] flex items-center justify-between">
                <ul className="flex items-center gap-[20px] text-[20px] font-[500] pl-[60px]">
                    {(LocaMapper[locaList] || []).map((loca, i) => (
                        <li
                            key={`loca_${i}`}
                            className={`first:text-[24px] first:font-[700]${
                                i > 0 ? " flex items-center gap-[20px]" : ""
                            }`}
                        >
                            {i > 0 && <img src={arrowRightGrayFill} alt="화살표" />}
                            <p>{loca}</p>
                        </li>
                    ))}
                </ul>
                <div className="flex items-center gap-[24px]">
                    <button
                        type="button"
                        onClick={() => window.open("/", "_blank")}
                        className="text-[16px] text-[#666] font-[500] flex items-center justify-center gap-[10px] border border-[#ddd] rounded-full leading-[34px] px-[10px]"
                    >
                        <span>사용자화면 바로가기</span>
                        <img src={icArrowOut} alt="화살표" />
                    </button>
                    <div className="w-[1px] h-[80px] bg-[#ddd]" />
                    <div className="flex items-center gap-[60px] pr-[60px]">
                        <p className="text-[20px] text-[#666]">
                            <strong className="underline text-[#222] font-[500]">{m_name}</strong> 님
                        </p>
                        <button type="button" onClick={handleLogout}>
                            <img src={icLogout} alt="로그아웃" />
                        </button>
                    </div>
                </div>
            </div>
            <Nav />
        </header>
    );
}
